// extracted by mini-css-extract-plugin
module.exports = {"root":"History_root__3_C4o","trackitem":"History_trackitem__THhbe","title":"History_title__2bUXu"};